import React from 'react';
import {Provider} from 'react-redux';
import {AuthProvider} from 'react-oidc-context';
import type {Store} from 'redux';
import {PersistGate} from 'redux-persist/integration/react';
import type {Persistor} from 'redux-persist/es/types';
import {authProviderProps} from '../authProviderProps';
import {AppRoutes} from './AppRoutes';
import {AuthGate} from './AuthGate';
import {ThemedApp} from './ThemedApp';

type Props = {
  store: Store;
  persistor: Persistor;
};

export const AppContainer: React.FC<Props> = ({store, persistor}) => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemedApp>
          <AuthProvider {...authProviderProps}>
            <AuthGate>
              <AppRoutes />
            </AuthGate>
          </AuthProvider>
        </ThemedApp>
      </PersistGate>
    </Provider>
  );
};
